export default {
  // Teams
  'rbac_settings.teams.delete_team_external_integration.dialog_content.text.delete_status_check.warning':
    'Are you sure you want to revoke this authentication? This will revoke the authentication on this team.',
  'rbac_settings.teams.delete_team_external_integration.dialog_content.text.delete_integration.warning':
    'Services using this integration will fail their Reliability Tests.',
  'rbac_settings.teams.notifications.scheduled_status_checks.failed_health_check.author_notification':
    'The scenario author {{enableSetting}} be notified of any failed Health Checks',
  'rbac_settings.teams.notifications.scheduled_status_checks.failed_health_check.team_notification':
    'Your team {{enableSetting}} be notified of any failed Health Checks',
  'rbac_settings.teams.notifications.scheduled_status_checks.row.header':
    'Scheduled Health Checks',
  'rbac_settings.teams.team_external_integration_authentication.authentication_type.header':
    '{{externalIntegrationType}} Authentication',

  // Security
  'rbac_settings.security.relay_state.tooltip.title':
    'Parameter used to specify company name and destination when logging in. Use this value when configuring your IDP for IDP initiated SAML logins.',

  // Preferences
  'rbac_settings.preferences.disable_target_all.label':
    'Target All For Ad-Hoc Attacks',
  'rbac_settings.preferences.disable_target_all.enabled.success.message':
    'Target All for ad-hoc attacks is enabled',
  'rbac_settings.preferences.disable_target_all.disabled.success.message':
    'Target All for ad-hoc attacks is disabled',
  'rbac_settings.preferences.disable_target_all.error.message':
    'We are unable to update the Target All For Ad-Hoc Attacks setting at this time. Please try again later.',
  'rbac_settings.preferences.experiment_visualizations.label':
    'Experiment Visualizations',
  'rbac_settings.preferences.experiment_visualizations.tooltip.text':
    'Gremlin will collect and store a limited set of attack metrics to display in charts. Please learn more about our',
  'rbac_settings.preferences.experiment_visualizations.tooltip.link.text':
    'data collection policies here.',
  'rbac_settings.preferences.experiment_visualizations.updated_by.text':
    'Updated by {{user}} on {{date}}',
  'rbac_settings.preferences.experiment_visualizations.enabled.success.message':
    'Experiment visualizations are enabled',
  'rbac_settings.preferences.experiment_visualizations.disabled.success.message':
    'Experiment visualizations are disabled',
  'rbac_settings.preferences.experiment_visualizations.error.message':
    'We are unable to update experiment visualizations at this time. Please try again later.',

  // Restricted Time Windows
  'rbac_settings.restricted_time_windows.patch.success.message':
    'Restricted time windows updated successfully',
  'rbac_settings.restricted_time_windows.patch.error.message':
    'There was an error updating the restricted time windows',
  'rbac_settings.restricted_time_windows.header': 'Restricted Time Windows',
  'rbac_settings.restricted_time_windows.subheader':
    'You can define time windows where tests, experiments, and scenarios will not be allowed to run for this team. Anything scheduled to run within these time windows will not begin. Up to {{maximumRestrictedTimeWindows}} restricted time windows can be defined per day.',
  'rbac_settings.restricted_time_windows.list.columns.start_time':
    'Start Time (UTC)',
  'rbac_settings.restricted_time_windows.list.columns.end_time':
    'End Time (UTC)',
  'rbac_settings.restricted_time_windows.list.empty_state':
    'No Restricted Times Defined',
  'rbac_settings.restricted_time_windows.list.caption': 'All times are in UTC',
  'rbac_settings.restricted_time_windows.drawer.selected_time_window.start_time.error':
    'Start time cannot fall within another restricted time window',
  'rbac_settings.restricted_time_windows.drawer.selected_time_window.end_time.error':
    'End time cannot fall within another restricted time window',
  'rbac_settings.restricted_time_windows.drawer.selected_time_window.contains_other_restricted_time_windows.error':
    'Selected time window contains other restricted time windows',
  'rbac_settings.restricted_time_windows.drawer.header': 'Select a time window',
  'rbac_settings.restricted_time_windows.drawer.tooltip.maximum_restricted_time_windows':
    'Maximum of {{maximumRestrictedTimeWindows}} restricted time windows allowed per day'
}
